import { type IBuyerSupportChatQuery } from 'application/querySchemas/IBuyerSupportChatQuery';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import {
    type IBuyerSupportChatMessagesClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IBuyerSupportChatMessagesClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class BuyerSupportChatQuery implements IBuyerSupportChatQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerSupportChatMessagesClient')
        public readonly buyerSupportChatMessagesClient: IBuyerSupportChatMessagesClient,
    ) {}

    public async fetchMessages(): Promise<IGetResponse['data']> {
        const { data, message } = await this.buyerSupportChatMessagesClient.get({
            token: this.buyerUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}

